<script setup>
import { computed } from 'vue'

const props = defineProps({
  title:   { type: String,           required: true  },
  value:   { type: [String, Number], required: true  },
  icon:    { type: String,           default: 'box'  },
  variant: { type: String,           default: 'default' },
  color:   { type: String,           default: null   },
})

const COLORS = {
  default:  '#4285f4',
  primary:  '#4285f4',
  critical: '#e53935',
  danger:   '#e53935',
  high:     '#f4511e',
  warning:  '#fb8c00',
  warn:     '#fb8c00',
  medium:   '#fb8c00',
  success:  '#43a047',
  ok:       '#43a047',
  green:    '#43a047',
  info:     '#5c6bc0',
  cyan:     '#00acc1',
  purple:   '#7e57c2',
  teal:     '#00897b',
  dark:     '#283593',
  neutral:  '#546e7a',
  muted:    '#78909c',
}

const accentColor = computed(() => {
  if (props.color) return props.color
  return COLORS[(props.variant || 'default').toLowerCase()] ?? COLORS.default
})
</script>

<template>
  <div class="wn-tile" :style="{ '--wn-c': accentColor }">
    <div class="wn-header">
      <i :class="`pi pi-${icon}`" class="wn-icon" />
      <span class="wn-label">{{ title }}</span>
    </div>
    <div class="wn-value">{{ value }}</div>
  </div>
</template>

<style scoped>
.wn-tile {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border: 1px solid var(--p-content-border-color, rgba(0,0,0,.08));
  border-left: 3px solid var(--wn-c);
  border-radius: 6px;
  background: var(--p-content-background, #fff);
  gap: 6px;
  min-height: 72px;
  transition: box-shadow .12s;
}

.wn-tile:hover {
  box-shadow: 0 2px 10px rgba(0,0,0,.08);
}

.wn-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wn-icon {
  font-size: .78rem;
  color: var(--wn-c);
  flex-shrink: 0;
}

.wn-label {
  font-size: .68rem;
  font-weight: 700;
  letter-spacing: .05em;
  text-transform: uppercase;
  color: var(--p-text-color-secondary);
  line-height: 1.2;
}

.wn-value {
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
  color: var(--p-text-color);
  letter-spacing: -.02em;
}

/* ── Dark mode ──────────────────────────────────────────────────── */
:global(.my-app-dark) .wn-tile {
  background: var(--p-surface-800, #1e293b);
  border-color: var(--p-surface-700, #334155);
  border-left-color: var(--wn-c);
}
</style>
